import { render, staticRenderFns } from "./ScrapReasons.vue?vue&type=template&id=4ab771d5"
import script from "./ScrapReasons.vue?vue&type=script&lang=ts"
export * from "./ScrapReasons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports